/* eslint-disable no-irregular-whitespace */
export const mediaCz = [
   
  {
    date: `22/10/2025`,
    name: `Milan Chytrý byl zvolen členem prestižní Academia Europaea`,
    resources: [`SCI MUNI`],
    links: [`https://www.sci.muni.cz/clanky/milan-chytry-byl-zvolen-clenem-prestizni-academia-europaea`]
  },    
  {
    date: `08/10/2025`,
    name: `Přijmout doktoranda mi dává smysl jen tehdy, když něco v oboru umí lépe než já. Rozhovor s Milanem Chytrým`,
    resources: [`Muni.cz`],
    links: [`https://kvalita.muni.cz/aktualne/aktuality/prijmout-doktoranda-mi-dava-smysl-jen-tehdy-kdyz-neco-v-oboru-umi-lepe-nez-ja-rozhovor-s-milanem-chytrym`]
  },
      
	  {
    date: `12/07/2025`,
    name: ` Rostliny z Panonie pomůžou trávníkům (od 10:20)`,
    resources: [`Český rozhlas`],
    links: [`https://www.mujrozhlas.cz/magazin-experiment/magazin-experiment-jak-se-ovlada-pocitac-ocima-jak-nebezpecni-jsou-parazite-z`]
  },    
  {
    date: `29/05/2025`,
    name: `Interview s Milanem Chytrým o konceptu temné diverzity (od času 8:51)`,
    resources: [`Český rozhlas`],
    links: [`https://www.mujrozhlas.cz/veda-plus/co-noveho-odbornici-zjistili-o-tom-v-jakem-stavu-je-stredoveky-cyklus-maleb-v-emauzskem`]
  },    
  {
    date: `21/04/2025`,
    name: `Rostliny mizí v přírodě i z míst, kde mají ideální podmínky k životu, alarmují vědci`,
    resources: [`Novinky.cz`],
    links: [`https://www.novinky.cz/clanek/veda-skoly-rostliny-mizi-v-prirode-i-z-mist-kde-maji-idealni-podminky-k-zivotu-alarmuji-vedci-40517313`]
  },    
  {
    date: `11/04/2025`,
    name: `Temná diverzita: V místech silně ovlivněných člověkem chybí rostlinné druhy, které by se tam jinak přirozeně vyskytovaly`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/temna-diverzita-v-mistech-silne-ovlivnenych-clovekem-chybi-rostlinne-druhy-ktere-by-se-tam-jinak-prirozene-vyskytovaly`]
  },    
  {
    date: `20/06/2024`,
    name: `Czech research highlights rapid decline in Europe’s biodiversity`,
    resources: [`Český rozhlas`],
    links: [`https://english.radio.cz/czech-research-highlights-rapid-decline-europes-biodiversity-8820517`]
  },    
  {
    date: `18/06/2024`,
    name: `Rozmanitost rostlin evropských lesů a luk rychle mizí`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/rozmanitost-rostlin-evropskych-lesu-a-luk-rychle-mizi-ukazuji-data-botaniku`]
  },    
  {
    date: `25/05/2024`,
    name: `Rovnováha ve stepi`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/1181680258-tyden-v-regionech-brno/324281381890525/cast/1047323/`]
  },    
  {
    date: `25/04/2024`,
    name: `Z české krajiny mizí původní druhy rostlin`,
    resources: [`CT24`],
    links: [`https://ct24.ceskatelevize.cz/clanek/veda/z-ceske-krajiny-mizi-puvodni-druhy-rostlin-naopak-se-siri-teplomilne-zjistila-studie-348709`]
  },
    
	{
    date: `05/04/2024`,
    name: `Botanici z Masarykovy univerzity zdokumentovali v Brně 1 492 planých druhů rostlin`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/v-brne-roste-1492-druhu-planych-nebo-zplanelych-rostlin-ukazala-studie`]
  },
    {
    date: `15/12/2023`,
    name: `Parasitische Pflanzen: Halbschmarotzer gegen Invasive Arten`,
    resources: [`Deutschlandfunk`],
    links: [`https://www.deutschlandfunk.de/parasitische-pflanzen-halbschmarotzer-gegen-invasive-arten-dlf-a25fa8ea-100.html`]
  },         
  {
    date: `24/11/2023`,
    name: `Kokrhel: poloparazit, který bohatým bere a chudým dává`,
    resources: [`Živá půda`],
    links: [`https://www.ziva-puda.cz/blog/kokrhel`]
  }, 
		{
    date: `13/10/2023`,
    name: `Rajčata lze sklízet později, o některé druhy rostlin ale můžeme přijít, říká o oteplování botanik`,
    resources: [`Deník N`],
    links: [`https://denikn.cz/1256428/rajcata-lze-sklizet-pozdeji-o-nektere-druhy-rostlin-ale-muzeme-prijit-rika-o-oteplovani-botanik`]
  }, 
  {
    date: `30/9/2023`,
    name: `Za oponou přírody: Tajemné louky v Karpatech`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/13608570834-za-oponou-prirody/`]
  },
  {
    date: `15/6/2023`,
    name: `Kokrhel a černýš pomáhají s údržbou trávníků v areálu kampusu`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/udalosti/16556-poloparaziticke-rostliny-pomahaji-pri-udrzbe-travniku-v-univerzitnim-kampusu-bohunice`]
  },
		   {
    date: `18/3/2023`,
    name: `Česko zachraňuje ohrožené rostliny. Pomoci může i mozaikové sečení`,
    resources: [`deník.cz`],
    links: [`https://www.denik.cz/z_domova/zachrana-ohrozenych-druhu-rostlin.html`]
  },
        {
    date: `18/3/2023`,
    name: `Kociánek dvoudomý mnoho mladých botaniků ani nevidělo`,
    resources: [`deník.cz`],
    links: [`https://www.denik.cz/z_domova/milan-chytry-ustav-botaniky-a-zoologie-ohrozene-druhy-rostlin.html`]
  }, 
        {
    date: `3/2/2023`,
    name: `Proč spolu žijí rostliny a jak mezi ně nejsnáze pronikne vetřelec`,
    resources: [`GAČR`],
    links: [`https://gacr.cz/proc-spolu-ziji-rostliny-a-jak-mezi-ne-nejsnaze-pronikne-vetrelec/`]
  },  
        {
    date: `11/1/2023`,
    name: `Kvetoucí příroda a mírná zima`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/1096902795-studio-6/223411010100111/cast/956142/`]
  },
        {
    date: `7/11/2022`,
    name: `Člověk a krajina v proměnách věků`,
    resources: [`Vesmir.cz`],
    links: [`https://www.youtube.com/watch?v=3CBVjcywJ7M`]
  },
  	  {
    date: `25/9/2021`,
    name: `Nečekaná obnova slanisk u Šakvic – zaniklý jihomoravský biotop se vrací do krajiny`,
    resources: [`Ekolist`, `Český rozhlas`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/necekana-obnova-slanisk-u-sakvic-zanikly-jihomoravsky-biotop-se-vraci-do-krajiny`, `https://plus.rozhlas.cz/novy-cesky-test-umi-jednoduseji-zjistit-uroven-protilatek-proti-nemoci-covid-19-8592889`]
  },
	  {
    date: `15/9/2022`,
    name: `Úspěch českých botaniků. Podíleli se na tvorbě nové celosvětové mapy biodiverzity rostlin`,
    resources: [`Novinky.cz`],
    links: [`https://www.novinky.cz/clanek/veda-skoly-uspech-ceskych-botaniku-podileli-se-na-tvorbe-nove-celosvetove-mapy-biodiverzity-rostlin-40408831`]
  },
      {
    date: `6/6/2021`,
    name: `Sčítání konikleců na Kamenném vrchu`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/scitani-koniklecu-na-kamennem-vrchu-v-brne-potvrdilo-svetovy-unikat-lokality`]
  },  
	  {
    date: `27/4/2021`,
    name: `Jak zmírnit úbytek druhové pestrosti`,
    resources: [`ČT Studio 6`],
    links: [`https://www.ceskatelevize.cz/porady/1096902795-studio-6/221411010100427/video/836062`]
  },
  {
    date: `27/4/2021`,
    name: `Krize biodiverzity`,
    resources: [`Učená společnost ČR`],
    links: [`https://www.youtube.com/watch?v=yfUl8HM89xg`]
  },
    {
    date: `16/3/2021`,
    name: `Vědci popsali rozdíly vývoje diverzity rostlin ve střední Evropě`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/vedci-popsali-rozdily-vyvoje-diverzity-rostlin-ve-stredni-evrope`]
  },
    {
    date: `27/8/2021`,
    name: `Rašeliništím se v Česku nedaří, říká nový červený seznam biotopů`,
    resources: [`Magazín M`, `Český rozhlas`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/13188-raselinistim-se-v-cesku-nedari-rika-novy-cerveny-seznam-biotopu`, `https://cesky.radio.cz/cerveny-seznam-biotopu-raselinistim-se-v-cesku-nedari-8691181`]
  },
    {
    date: `24/6/2020`,
    name: `Extrémní sucha ovlivňují i přirozeně nejsušší biotopy jižní Moravy`,
    resources: [`Magazín M`, `iDnes`, `Ekolist`],
    links: [`https://www.em.muni.cz/vite/13036-extremni-sucha-ovlivnuji-i-prirozene-nejsussi-biotopy-jizni-moravy`, `https://www.idnes.cz/brno/zpravy/sucho-palava-ohrozene-stepni-rostliny.A200703_557329_brno-zpravy_mls`, `https://ekolist.cz/cz/zpravodajstvi/zpravy/dlouhodobe-sucho-negativne-ovlivnuje-i-skalni-stepi-na-palave`]  
   },
  {
    date: `12/5/2020`,
    name: `V žaludcích mamutů našli vědci krajinu doby ledové`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/12856-v-zaludcich-mamutu-nasli-vedci-krajinu-doby-ledove`]
  },
  {
    date: `8/3/2020`,
    name: `Brněnští vědci nahlédli do mamutích žaludků. A poodhalili podobu pravěkého světa`,
    resources: [`ČT24`, `Český rozhlas`,` Lidovky`, `Týden`],
    links: [`https://ct24.ceskatelevize.cz/veda/3058902-brnensti-vedci-nahledli-do-mamutich-zaludku-a-poodhalili-podobu-pravekeho-sveta`, `https://plus.rozhlas.cz/cesti-vedci-dokreslili-obraz-praveke-sibire-8164645?`, `https://www.lidovky.cz/relax/veda/obsah-mamutich-zaludku-vedcum-odhaluje-prirodu-doby-ledove.A200310_105806_ln_veda_ape`, `https://www.tyden.cz/rubriky/veda/mamuti-zaludky-pomahaji-vedcum-odhalit-prirodu-doby-ledove_540444.html`]
  },
  {
    date: `3/12/2019`,
    name: `Botanici připravili nový klíč k určování rostlin. Minulý rychle zastaral`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/12300-botanici-pripravili-novy-klic-k-urcovani-rostlin?utm_source=fb_em&utm_medium=link&utm_campaign=facebook&fbclid=IwAR1--TWGjN1AddSnfvrM0w0geju_Yv_mkdOGzkKbLuhH3uMSn2yECESz45A`]
  },
  {
    date: `22/8/2019`,
    name: `Botanici zmapovali druhové bohatství evropských lesů`,
    resources: [`ČT Události v regionech`,`ČT24`, `Magazín M`],
    links: [`https://www.ceskatelevize.cz/porady/10122427178-udalosti-v-regionech-brno/319281381990819-udalosti-v-regionech/video/714129`, `https://ct24.ceskatelevize.cz/regiony/jihomoravsky-kraj/2900171-brnensti-vedci-mapuji-rozmanitost-evropskych-lesu-cesko-je`, `https://www.em.muni.cz/veda-a-vyzkum/11988-botanici-zmapovali-druhove-bohatstvi-evropskych-lesu`]
  },
{
    date: `12/7/2019`,
    name: `Sekání trávy ve městech`,
    resources: [`ČT Události v regionech`],
    links: [`https://www.ceskatelevize.cz/porady/10122427178-udalosti-v-regionech-brno/319281381990712-udalosti-v-regionech/video/707729`]
  },
  {
    date: `7/11/2018`,
    name: `Brněnští vědci odhalili tajemství úspěchu invazivních rostlin`,
    resources: [`Pozitivní zprávy`,`ČT24`, `ScienceMag`, `Online.muni.cz`],
    links: [`https://pozitivni-zpravy.cz/cesti-vedci-rozklicovali-tajemstvi-uspechu-invazivnich-rostlin/`,`https://ct24.ceskatelevize.cz/veda/2644739-brnensti-vedci-odhalili-tajemstvi-uspechu-invazivnich-rostlin-hlavni-roli-podle-nich`, `https://sciencemag.cz/invazni-rostliny-jsou-v-prumeru-vyssi-nez-puvodni-druhy/`, `https://www.online.muni.cz/veda-a-vyzkum/11178-objev-invazni-rostliny-jsou-v-prumeru-vyssi-nez-puvodni-druhy`]
  },
  {
    date: `1/4/2018`,
    name: `Každý druh má v ekosystému svou roli`,
    resources: [`Online.muni.cz`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/10378-kazdy-druh-ma-v-ekosystemu-svou-roli`]
  },
  {
    date: `24/3/2018`,
    name: `Česká flóra a vegetace na jednom místě`,
    resources: [`Česká televize, Studio 6`],
    links: [`https://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/218411010120324/obsah/609284-ceska-flora-a-vegetace-na-jednom-miste`]
  },
  {
    date: `20/3/2018`,
    name: `Botanici spustili nejrozsáhlejší online databázi české flóry a vegetace`,
    resources: [`Česká televize`, `MUNI`, `Radio.cz`, `Sciencemag`, `Ekolist`, `Enviweb`, `21. století`, `Týden.cz`],
    links: [`http://www.ceskatelevize.cz/ct24/veda/2424340-cela-kvetena-na-jednom-miste-botanici-spustili-nejrozsahlejsi-online-databazi-ceske`,
	`https://www.online.muni.cz/veda-a-vyzkum/10368-botanici-spustili-nejrozsahlejsi-online-databazi-ceske-flory-a-vegetace`,
	`http://www.radio.cz/ru/rubrika/radiogazeta/vsya-flora-chexii-na-odnom-sajte`,
	`http://sciencemag.cz/nejrozsahlejsi-online-databaze-ceske-flory-a-vegetace/`, `https://ekolist.cz/cz/zpravodajstvi/zpravy/ode-dneska-je-pristupna-nejrozsahlejsi-online-databaze-ceske-flory-a-vegetace`,
	`http://www.enviweb.cz/rss/164353`, `https://21stoleti.cz/2018/03/21/veskere-informace-o-ceske-kvetene-na-jednom-miste/`, `https://www.tyden.cz/rubriky/veda/priroda/webova-databaze-shrnuje-informace-o-flore-a-vegetaci-v-cesku_472193.html`, ]
  },
  {
    date: `11/3/2018`,
    name: `Evropské druhy rostlin obsadily svět díky soužití s člověkem`,
    resources: [`MUNI`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/10308-evropske-druhy-rostlin-obsadily-svet-diky-souziti-s-clovekem`]
  },
  
    {
    date: `9/1/2018`,
    name: `Evropské rostliny ve světě`,
    resources: [`Česká televize (1:11:00)`],
    links: [`https://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/218411058060109`]
  },
  {
    date: `9/3/2017`,
    name: `Červený seznam ohrožených ekosystémů`,
    resources: [`Česká televize, Studio 6`],
    links: [`https://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/217411010100309/obsah/528996-seznam-ohrozenych-ekosystemu-v-evrope`]
  },
  {
    date: `19/1/2017`,
    name: `První evropský červený seznam biotopů`,
    resources: [`Online.muni.cz`, `Ekolist.cz`, `Týden.cz`, `Lidovky.cz (29/1)`, `Brněnský Deník (8/2)`],
    links: [`https://www.online.muni.cz/veda-a-vyzkum/8740-desitky-typu-evropske-prirody-jsou-v-ohrozeni-biologove-sestavili-cerveny-seznam`, `http://ekolist.cz/cz/zpravodajstvi/zpravy/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci`, `http://www.tyden.cz/rubriky/veda/priroda/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci_414283.html`,  `http://relax.lidovky.cz/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci-pxe-/veda.aspx?c=A170123_163447_ln_veda_ape`, `http://botzool.sci.muni.cz/news/2017_02_08_chytry_Brnensky_denik.jpg`]
  },
  {
    date: `6/12/2016`,
    name: `První úplný přehled typů evropské vegetace`,
    resources: [`Online.muni.cz`],
    links: [`https://www.online.muni.cz/veda-a-vyzkum/8576-botanici-muni-pomohli-s-popisem-evropske-vegetace-pomuze-chranit-prirodu?utm_source=fb_milujeme&utm_medium=link&utm_campaign=facebook`]
  },
  {
    date: `30/01/2014`,
    name: `Ice age thrives in Southern Siberia`,
    resources: [`Radio Free Europe`],
    links: [`http://www.rferl.org/content/russia-mongolia-altai-ice-age-species/25247802.html`]
  },
  {
    date: `13/7/2014`,
    name: `Aplikace určí rostlinu na počkání`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/4532-aplikace-urci-rostlinu-na-pockani#.VBhSt_l_sn4`]
  },
  {
    date: `23/01/2014`,
    name: `Ice-age animals live on in Eurasian mountain range`,
    resources: [`New Scientist`],
    links: [`http://www.newscientist.com/article/mg22129533.800-iceage-animals-live-on-in-eurasian-mountain-range.html#.UygwyNtIw8E`]
  },
  {
    date: `11/3/2013`,
    name: `Studentka vrací přírodu do lomu`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/student/3343-studentka-vraci-prirodu-do-lomu#.VBhUqPl_sn4`]
  },
    {
    date: `3/1/2013`,
    name: `Aktuální soupis naší flóry (Jiří Danihelka)`,
    resources: [`Český rozhlas Leonardo`],
    links: [`https://hledani.rozhlas.cz/iRadio/?query=danihelka&reader=&stanice%5B%5D=%C4%8CRo+Leonardo&porad%5B%5D=`]
  },
{
    date: `21/01/2013`,
    name: `Zničilo mamuty iba globálne otepľovanie?`,
    resources: [`Plus 7 dní`],
    links: [`https://plus7dni.pluska.sk/relax/znicilo-mamuty-iba-globalne-oteplovanie?itm_site=plus7&itm_template=gallery&itm_area=relax&itm_modul=spat-na-clanok`]
  },
  {
    date: `27/11/2012`,
    name: `Vegetace doby ledové na dosah?`,
    resources: [`Česká televize – Před půlnocí`],
    links: [`http://www.ceskatelevize.cz/ivysilani/10095690193-pred-pulnoci/312281381940091/`]
  },
  {
    date: `26/11/2012`,
    name: `Na Sibiři zkoumají českou dobu ledovou`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/3267-na-sibiri-zkoumaji-ceskou-dobu-ledovou#.VBhSzvl_sn4`]
  },
      {
    date: `6/6/2012`,
    name: `Invaze cizokrajných rostlin v hledáčku botaniků`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/3001-invaze-cizokrajnych-rostlin-v-hledacku-botaniku#.VBhS3fl_sn4`]
  },
  {
    date: `05/08/2012`,
    name: `Proč vyhynuli mamuti? Odpověď jezdí český vědec hledat na Sibiř`,
    resources: [`Hospodářské noviny`],
    links: [`http://zpravy.ihned.cz/cesko/c1-56913430-proc-vyhynuli-mamuti-odpoved-jezdi-cesky-vedec-hledat-na-sibir`]
  },
	{
    date: `05/01/2007`,
    name: `Česko v době ledové`,
    resources: [`Český rozhlas`],
    links: [`https://temata.rozhlas.cz/cesko-v-dobe-ledove-7851787`]
  },
      {
    date: `05/2007`,
    name: `Doba ledová nebyla tak hrozivá`,
    resources: [`21. století`],
    links: [`http://www.sci.muni.cz/botany/vz/pdf/Velinsky2007_21-stoleti.pdf`]
  },
  
  ];

export const mediaEn = [
{
    date: `22/10/2025`,
    name: `Milan Chytrý byl zvolen členem prestižní Academia Europaea`,
    resources: [`SCI MUNI`],
    links: [`https://www.sci.muni.cz/clanky/milan-chytry-byl-zvolen-clenem-prestizni-academia-europaea`]
  },    
  {
    date: `08/10/2025`,
    name: `Přijmout doktoranda mi dává smysl jen tehdy, když něco v oboru umí lépe než já. Rozhovor s Milanem Chytrým`,
    resources: [`Muni.cz`],
    links: [`https://kvalita.muni.cz/aktualne/aktuality/prijmout-doktoranda-mi-dava-smysl-jen-tehdy-kdyz-neco-v-oboru-umi-lepe-nez-ja-rozhovor-s-milanem-chytrym`]
  },
      
	  {
    date: `12/07/2025`,
    name: ` Rostliny z Panonie pomůžou trávníkům (od 10:20)`,
    resources: [`Český rozhlas`],
    links: [`https://www.mujrozhlas.cz/magazin-experiment/magazin-experiment-jak-se-ovlada-pocitac-ocima-jak-nebezpecni-jsou-parazite-z`]
  },    
  {
    date: `29/05/2025`,
    name: `Interview s Milanem Chytrým o konceptu temné diverzity (od času 8:51)`,
    resources: [`Český rozhlas`],
    links: [`https://www.mujrozhlas.cz/veda-plus/co-noveho-odbornici-zjistili-o-tom-v-jakem-stavu-je-stredoveky-cyklus-maleb-v-emauzskem`]
  },    
  {
    date: `21/04/2025`,
    name: `Rostliny mizí v přírodě i z míst, kde mají ideální podmínky k životu, alarmují vědci`,
    resources: [`Novinky.cz`],
    links: [`https://www.novinky.cz/clanek/veda-skoly-rostliny-mizi-v-prirode-i-z-mist-kde-maji-idealni-podminky-k-zivotu-alarmuji-vedci-40517313`]
  },    
  {
    date: `11/04/2025`,
    name: `Temná diverzita: V místech silně ovlivněných člověkem chybí rostlinné druhy, které by se tam jinak přirozeně vyskytovaly`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/temna-diverzita-v-mistech-silne-ovlivnenych-clovekem-chybi-rostlinne-druhy-ktere-by-se-tam-jinak-prirozene-vyskytovaly`]
  },    
  {
    date: `20/06/2024`,
    name: `Czech research highlights rapid decline in Europe’s biodiversity`,
    resources: [`Český rozhlas`],
    links: [`https://english.radio.cz/czech-research-highlights-rapid-decline-europes-biodiversity-8820517`]
  },    
  {
    date: `18/06/2024`,
    name: `Rozmanitost rostlin evropských lesů a luk rychle mizí`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/rozmanitost-rostlin-evropskych-lesu-a-luk-rychle-mizi-ukazuji-data-botaniku`]
  },    
  {
    date: `25/05/2024`,
    name: `Rovnováha ve stepi`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/1181680258-tyden-v-regionech-brno/324281381890525/cast/1047323/`]
  },    
  {
    date: `25/04/2024`,
    name: `Z české krajiny mizí původní druhy rostlin`,
    resources: [`CT24`],
    links: [`https://ct24.ceskatelevize.cz/clanek/veda/z-ceske-krajiny-mizi-puvodni-druhy-rostlin-naopak-se-siri-teplomilne-zjistila-studie-348709`]
  },
    
	{
    date: `05/04/2024`,
    name: `Botanici z Masarykovy univerzity zdokumentovali v Brně 1 492 planých druhů rostlin`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/v-brne-roste-1492-druhu-planych-nebo-zplanelych-rostlin-ukazala-studie`]
  },
  {
    date: `15/12/2023`,
    name: `Parasitische Pflanzen: Halbschmarotzer gegen Invasive Arten`,
    resources: [`Deutschlandfunk`],
    links: [`https://www.deutschlandfunk.de/parasitische-pflanzen-halbschmarotzer-gegen-invasive-arten-dlf-a25fa8ea-100.html`]
  },         
  {
    date: `24/11/2023`,
    name: `Kokrhel: poloparazit, který bohatým bere a chudým dává`,
    resources: [`Živá půda`],
    links: [`https://www.ziva-puda.cz/blog/kokrhel`]
  }, 
		{
    date: `13/10/2023`,
    name: `Rajčata lze sklízet později, o některé druhy rostlin ale můžeme přijít, říká o oteplování botanik`,
    resources: [`Deník N`],
    links: [`https://denikn.cz/1256428/rajcata-lze-sklizet-pozdeji-o-nektere-druhy-rostlin-ale-muzeme-prijit-rika-o-oteplovani-botanik`]
  }, 
  {
    date: `30/9/2023`,
    name: `Za oponou přírody: Tajemné louky v Karpatech`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/13608570834-za-oponou-prirody/`]
  },
  {
    date: `15/6/2023`,
    name: `Kokrhel a černýš pomáhají s údržbou trávníků v areálu kampusu`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/udalosti/16556-poloparaziticke-rostliny-pomahaji-pri-udrzbe-travniku-v-univerzitnim-kampusu-bohunice`]
  },
		   {
    date: `18/3/2023`,
    name: `Česko zachraňuje ohrožené rostliny. Pomoci může i mozaikové sečení`,
    resources: [`deník.cz`],
    links: [`https://www.denik.cz/z_domova/zachrana-ohrozenych-druhu-rostlin.html`]
  },
        {
    date: `18/3/2023`,
    name: `Kociánek dvoudomý mnoho mladých botaniků ani nevidělo`,
    resources: [`deník.cz`],
    links: [`https://www.denik.cz/z_domova/milan-chytry-ustav-botaniky-a-zoologie-ohrozene-druhy-rostlin.html`]
  }, 
        {
    date: `3/2/2023`,
    name: `Proč spolu žijí rostliny a jak mezi ně nejsnáze pronikne vetřelec`,
    resources: [`GAČR`],
    links: [`https://gacr.cz/proc-spolu-ziji-rostliny-a-jak-mezi-ne-nejsnaze-pronikne-vetrelec/`]
  },  
        {
    date: `11/1/2023`,
    name: `Kvetoucí příroda a mírná zima`,
    resources: [`Česká televize`],
    links: [`https://www.ceskatelevize.cz/porady/1096902795-studio-6/223411010100111/cast/956142/`]
  },
        {
    date: `7/11/2022`,
    name: `Člověk a krajina v proměnách věků`,
    resources: [`Vesmir.cz`],
    links: [`https://www.youtube.com/watch?v=3CBVjcywJ7M`]
  },
	  {
    date: `25/9/2021`,
    name: `Nečekaná obnova slanisk u Šakvic – zaniklý jihomoravský biotop se vrací do krajiny`,
    resources: [`Ekolist`, `Český rozhlas`],
    links: [`https://ekolist.cz/cz/publicistika/priroda/necekana-obnova-slanisk-u-sakvic-zanikly-jihomoravsky-biotop-se-vraci-do-krajiny`, `https://plus.rozhlas.cz/novy-cesky-test-umi-jednoduseji-zjistit-uroven-protilatek-proti-nemoci-covid-19-8592889`]
  },	 
	 {
    date: `15/9/2022`,
    name: `Úspěch českých botaniků. Podíleli se na tvorbě nové celosvětové mapy biodiverzity rostlin`,
    resources: [`Novinky.cz`],
    links: [`https://www.novinky.cz/clanek/veda-skoly-uspech-ceskych-botaniku-podileli-se-na-tvorbe-nove-celosvetove-mapy-biodiverzity-rostlin-40408831`]
  },      
      {
    date: `6/6/2021`,
    name: ` Sčítání konikleců na Kamenném vrchu`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/scitani-koniklecu-na-kamennem-vrchu-v-brne-potvrdilo-svetovy-unikat-lokality`]
  },  
	  {
    date: `27/4/2021`,
    name: ` Jak zmírnit úbytek druhové pestrosti`,
    resources: [`ČT Studio 6`],
    links: [`https://www.ceskatelevize.cz/porady/1096902795-studio-6/221411010100427/video/836062`]
  },
  {
    date: `27/4/2021`,
    name: `Krize biodiverzity`,
    resources: [`Učená společnost ČR`],
    links: [`https://www.youtube.com/watch?v=yfUl8HM89xg`]
  },
    {
    date: `16/3/2021`,
    name: ` Vědci popsali rozdíly vývoje diverzity rostlin ve střední Evropě`,
    resources: [`Ekolist`],
    links: [`https://ekolist.cz/cz/zpravodajstvi/zpravy/vedci-popsali-rozdily-vyvoje-diverzity-rostlin-ve-stredni-evrope`]
  },
    {
    date: `27/8/2021`,
    name: `Rašeliništím se v Česku nedaří, říká nový červený seznam biotopů`,
    resources: [`Magazín M`, `Český rozhlas`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/13188-raselinistim-se-v-cesku-nedari-rika-novy-cerveny-seznam-biotopu`, `https://cesky.radio.cz/cerveny-seznam-biotopu-raselinistim-se-v-cesku-nedari-8691181`]
  },
    {
    date: `24/6/2020`,
    name: `Extrémní sucha ovlivňují i přirozeně nejsušší biotopy jižní Moravy`,
    resources: [`Magazín M`, `iDnes`, `Ekolist`],
    links: [`https://www.em.muni.cz/vite/13036-extremni-sucha-ovlivnuji-i-prirozene-nejsussi-biotopy-jizni-moravy`, `https://www.idnes.cz/brno/zpravy/sucho-palava-ohrozene-stepni-rostliny.A200703_557329_brno-zpravy_mls`, `https://ekolist.cz/cz/zpravodajstvi/zpravy/dlouhodobe-sucho-negativne-ovlivnuje-i-skalni-stepi-na-palave`]  
   },
   {
    date: `12/5/2020`,
    name: `V žaludcích mamutů našli vědci krajinu doby ledové`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/12856-v-zaludcich-mamutu-nasli-vedci-krajinu-doby-ledove`]
  },
  {
    date: `8/3/2020`,
    name: `Brněnští vědci nahlédli do mamutích žaludků. A poodhalili podobu pravěkého světa`,
    resources: [`ČT24`, `Český rozhlas`,` Lidovky`, `Týden`],
    links: [`https://ct24.ceskatelevize.cz/veda/3058902-brnensti-vedci-nahledli-do-mamutich-zaludku-a-poodhalili-podobu-pravekeho-sveta`, `https://plus.rozhlas.cz/cesti-vedci-dokreslili-obraz-praveke-sibire-8164645?`, `https://www.lidovky.cz/relax/veda/obsah-mamutich-zaludku-vedcum-odhaluje-prirodu-doby-ledove.A200310_105806_ln_veda_ape`, `https://www.tyden.cz/rubriky/veda/mamuti-zaludky-pomahaji-vedcum-odhalit-prirodu-doby-ledove_540444.html`]
  },
  {
    date: `3/12/2019`,
    name: `Botanici připravili nový klíč k určování rostlin. Minulý rychle zastaral`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/12300-botanici-pripravili-novy-klic-k-urcovani-rostlin?utm_source=fb_em&utm_medium=link&utm_campaign=facebook&fbclid=IwAR1--TWGjN1AddSnfvrM0w0geju_Yv_mkdOGzkKbLuhH3uMSn2yECESz45A`]
  },
  {
    date: `22/8/2019`,
    name: `Botanici zmapovali druhové bohatství evropských lesů`,
    resources: [`ČT Události v regionech`,`ČT24`, `Magazín M`],
    links: [`https://www.ceskatelevize.cz/porady/10122427178-udalosti-v-regionech-brno/319281381990819-udalosti-v-regionech/video/714129`, `https://ct24.ceskatelevize.cz/regiony/jihomoravsky-kraj/2900171-brnensti-vedci-mapuji-rozmanitost-evropskych-lesu-cesko-je`, `https://www.em.muni.cz/veda-a-vyzkum/11988-botanici-zmapovali-druhove-bohatstvi-evropskych-lesu`]
  },
{
    date: `12/7/2019`,
    name: `Sekání trávy ve městech`,
    resources: [`ČT Události v regionech`],
    links: [`https://www.ceskatelevize.cz/porady/10122427178-udalosti-v-regionech-brno/319281381990712-udalosti-v-regionech/video/707729`]
  },
  {
    date: `7/11/2018`,
    name: `Brněnští vědci odhalili tajemství úspěchu invazivních rostlin`,
    resources: [`Pozitivní zprávy`,`ČT24`, `ScienceMag`, `Online.muni.cz`],
    links: [`https://pozitivni-zpravy.cz/cesti-vedci-rozklicovali-tajemstvi-uspechu-invazivnich-rostlin/`,`https://ct24.ceskatelevize.cz/veda/2644739-brnensti-vedci-odhalili-tajemstvi-uspechu-invazivnich-rostlin-hlavni-roli-podle-nich`, `https://sciencemag.cz/invazni-rostliny-jsou-v-prumeru-vyssi-nez-puvodni-druhy/`, `https://www.online.muni.cz/veda-a-vyzkum/11178-objev-invazni-rostliny-jsou-v-prumeru-vyssi-nez-puvodni-druhy`]
  },
  {
    date: `1/4/2018`,
    name: `Každý druh má v ekosystému svou roli`,
    resources: [`Online.muni.cz`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/10378-kazdy-druh-ma-v-ekosystemu-svou-roli`]
  },
  {
    date: `24/3/2018`,
    name: `Česká flóra a vegetace na jednom místě`,
    resources: [`Česká televize, Studio 6`],
    links: [`https://www.ceskatelevize.cz/ivysilani/10441287766-studio-6-vikend/218411010120324/obsah/609284-ceska-flora-a-vegetace-na-jednom-miste`]
  },
  {
    date: `20/3/2018`,
    name: `Botanici spustili nejrozsáhlejší online databázi české flóry a vegetace`,
    resources: [`Česká televize`, `MUNI`, `Radio.cz`, `Sciencemag`, `Ekolist`, `Enviweb`, `21. století`, `Týden.cz`],
    links: [`http://www.ceskatelevize.cz/ct24/veda/2424340-cela-kvetena-na-jednom-miste-botanici-spustili-nejrozsahlejsi-online-databazi-ceske`,
	`https://www.online.muni.cz/veda-a-vyzkum/10368-botanici-spustili-nejrozsahlejsi-online-databazi-ceske-flory-a-vegetace`,
	`http://www.radio.cz/ru/rubrika/radiogazeta/vsya-flora-chexii-na-odnom-sajte`,
	`http://sciencemag.cz/nejrozsahlejsi-online-databaze-ceske-flory-a-vegetace/`, `https://ekolist.cz/cz/zpravodajstvi/zpravy/ode-dneska-je-pristupna-nejrozsahlejsi-online-databaze-ceske-flory-a-vegetace`,
	`http://www.enviweb.cz/rss/164353`, `https://21stoleti.cz/2018/03/21/veskere-informace-o-ceske-kvetene-na-jednom-miste/`, `https://www.tyden.cz/rubriky/veda/priroda/webova-databaze-shrnuje-informace-o-flore-a-vegetaci-v-cesku_472193.html`, ]
  },
  {
    date: `11/3/2018`,
    name: `Evropské druhy rostlin obsadily svět díky soužití s člověkem`,
    resources: [`MUNI`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/10308-evropske-druhy-rostlin-obsadily-svet-diky-souziti-s-clovekem`]
  },
  
    {
    date: `9/1/2018`,
    name: `Evropské rostliny ve světě`,
    resources: [`Česká televize (1:11:00)`],
    links: [`https://www.ceskatelevize.cz/ivysilani/10101491767-studio-ct24/218411058060109`]
  },
  {
    date: `9/3/2017`,
    name: `Červený seznam ohrožených ekosystémů`,
    resources: [`Česká televize, Studio 6`],
    links: [`https://www.ceskatelevize.cz/ivysilani/1096902795-studio-6/217411010100309/obsah/528996-seznam-ohrozenych-ekosystemu-v-evrope`]
  },
  {
    date: `19/1/2017`,
    name: `První evropský červený seznam biotopů`,
    resources: [`Online.muni.cz`, `Ekolist.cz`, `Týden.cz`, `Lidovky.cz (29/1)`, `Brněnský Deník (8/2)`],
    links: [`https://www.online.muni.cz/veda-a-vyzkum/8740-desitky-typu-evropske-prirody-jsou-v-ohrozeni-biologove-sestavili-cerveny-seznam`, `http://ekolist.cz/cz/zpravodajstvi/zpravy/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci`, `http://www.tyden.cz/rubriky/veda/priroda/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci_414283.html`,  `http://relax.lidovky.cz/z-evropy-mizi-nektere-typy-prirodnich-stanovist-zjistili-vedci-pxe-/veda.aspx?c=A170123_163447_ln_veda_ape`, `http://botzool.sci.muni.cz/news/2017_02_08_chytry_Brnensky_denik.jpg`]
  },
  {
    date: `6/12/2016`,
    name: `První úplný přehled typů evropské vegetace`,
    resources: [`Online.muni.cz`],
    links: [`https://www.online.muni.cz/veda-a-vyzkum/8576-botanici-muni-pomohli-s-popisem-evropske-vegetace-pomuze-chranit-prirodu?utm_source=fb_milujeme&utm_medium=link&utm_campaign=facebook`]
  },
  {
    date: `30/01/2014`,
    name: `Ice age thrives in Southern Siberia`,
    resources: [`Radio Free Europe`],
    links: [`http://www.rferl.org/content/russia-mongolia-altai-ice-age-species/25247802.html`]
  },
  {
    date: `13/7/2014`,
    name: `Aplikace určí rostlinu na počkání`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/4532-aplikace-urci-rostlinu-na-pockani#.VBhSt_l_sn4`]
  },
  {
    date: `23/01/2014`,
    name: `Ice-age animals live on in Eurasian mountain range`,
    resources: [`New Scientist`],
    links: [`http://www.newscientist.com/article/mg22129533.800-iceage-animals-live-on-in-eurasian-mountain-range.html#.UygwyNtIw8E`]
  },
  {
    date: `11/3/2013`,
    name: `Studentka vrací přírodu do lomu`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/student/3343-studentka-vraci-prirodu-do-lomu#.VBhUqPl_sn4`]
  },
    {
    date: `3/1/2013`,
    name: `Aktuální soupis naší flóry (Jiří Danihelka)`,
    resources: [`Český rozhlas Leonardo`],
    links: [`https://hledani.rozhlas.cz/iRadio/?query=danihelka&reader=&stanice%5B%5D=%C4%8CRo+Leonardo&porad%5B%5D=`]
  },
{
    date: `21/01/2013`,
    name: `Zničilo mamuty iba globálne otepľovanie?`,
    resources: [`Plus 7 dní`],
    links: [`https://plus7dni.pluska.sk/relax/znicilo-mamuty-iba-globalne-oteplovanie?itm_site=plus7&itm_template=gallery&itm_area=relax&itm_modul=spat-na-clanok`]
  },
  {
    date: `27/11/2012`,
    name: `Vegetace doby ledové na dosah?`,
    resources: [`Česká televize – Před půlnocí`],
    links: [`http://www.ceskatelevize.cz/ivysilani/10095690193-pred-pulnoci/312281381940091/`]
  },
  {
    date: `26/11/2012`,
    name: `Na Sibiři zkoumají českou dobu ledovou`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/3267-na-sibiri-zkoumaji-ceskou-dobu-ledovou#.VBhSzvl_sn4`]
  },
      {
    date: `6/6/2012`,
    name: `Invaze cizokrajných rostlin v hledáčku botaniků`,
    resources: [`Magazín M`],
    links: [`https://www.em.muni.cz/veda-a-vyzkum/3001-invaze-cizokrajnych-rostlin-v-hledacku-botaniku#.VBhS3fl_sn4`]
  },
  {
    date: `05/08/2012`,
    name: `Proč vyhynuli mamuti? Odpověď jezdí český vědec hledat na Sibiř`,
    resources: [`Hospodářské noviny`],
    links: [`http://zpravy.ihned.cz/cesko/c1-56913430-proc-vyhynuli-mamuti-odpoved-jezdi-cesky-vedec-hledat-na-sibir`]
  },
	{
    date: `05/01/2007`,
    name: `Česko v době ledové`,
    resources: [`Český rozhlas`],
    links: [`https://temata.rozhlas.cz/cesko-v-dobe-ledove-7851787`]
  },
      {
    date: `05/2007`,
    name: `Doba ledová nebyla tak hrozivá`,
    resources: [`21. století`],
    links: [`http://www.sci.muni.cz/botany/vz/pdf/Velinsky2007_21-stoleti.pdf`]
  },
  
  ];

export const popularizationCz = [
{
    date: `2023`,
    name: `Zelkova habrolistá - pamětnice třetihor pod Kavkazem`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/2023-3/zelkova-habrolista-pametnice-tretihor-pod-kavkazem.html`]
  },
  {
    date: `2022`,
    name: `Hlaváček letní, rostlina roku 2022, a jeho příbuzní`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/hlavacek-letni-rostlina-roku-2022-a-jeho-pribuzni.pdf`]
  },
    {
    date: `2022`,
    name: `Nerovnováhou k stabilitě`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2022/cislo-2/nerovnovahou-k-stabilite.html`]
  },
{
    date: `2022`,
    name: `Zamrzlé safari`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2022/cislo-3/zamrzle-safari.html`]
  },
{
    date: `2021`,
    name: `Parazitické rostliny: Pomocníci v boji s rostlinnými invazemi a expanzemi?`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2021/cislo-4/paraziticke-rostliny.html`]
  },{
    date: `2020`,
    name: `Teplomilné rostlinstvo Podkarpatské Rusi`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/2020-1/teplomilne-rostlinstvo-podkarpatske-rusi.html`]
  },{
    date: `2019`,
    name: `Biogeografie druhové diverzity rostlinných společenstev`,
    resources: [`Živa`],
    links: [`https://www.sci.muni.cz/botany/chytry/Chytry_etal2019_Ziva.pdf`]
  },
  {
    date: `2019`,
    name: `Comeback středoevropské lesostepi`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2019/cislo-7/comeback-stredoevropske-lesostepi.html`]
  },
  {
    date: `2019`,
    name: `Podpěrovské inspirace v botanice`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pd/pdf/podperovske-inspirace-v-botanice.pdf`]
  },
{
    date: `2019`,
    name: `Stepi západní Ukrajiny`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/2019-4/stepi-zapadni-ukrajiny.html`]
  },
  {
    date: `2018`,
    name: `Tvář jihomoravského luhu se mění`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/tvar-jihomoravskeho-luhu-se-meni.pdf`]
  },
  {
    date: `2018`,
    name: `Evropský červený seznam biotopů`,
    resources: [`Ochrana přírody`],
    links: [`https://www.sci.muni.cz/botany/chytry/Chytry2018_Ochr-Prir.pdf`]
  },
  {
    date: `2018`,
    name: `Biotopy jako zdroje i příjemci nepůvodních druhů rostlin`,
    resources: [`Živa`],
    links: [`https://www.sci.muni.cz/botany/chytry/Hejda_etal2018_Ziva.pdf`]
  },
{
    date: `2018`,
    name: `Známe odpověď na Darwinovu naturalizační hádanku?`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/zname-odpoved-na-darwinovu-naturalizacni-hadanku.pdf`]
  },
  {
    date: `2018`,
    name: `Rostlinné invaze na antropogenních stanovištích`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/rostlinne-invaze-na-antropogennich-stanovistich.pdf`]
  },
  {
    date: `2017`,
    name: `Za botanickými krásami jižní Kolchidy I.`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/za-botanickymi-krasami-jizni-kolchidy-i.pdf`]
  },
  {
    date: `2017`,
    name: `Za botanickými krásami jižní Kolchidy II.`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/za-botanickymi-krasami-jizni-kolchidy-ii.pdf`]
  },
  {
    date: `2016`,
    name: `Vliv akumulace dusíku na vřesoviště a suché trávníky v Národním parku Podyjí`,
    resources: [`Životné prostredie`],
    links: [`https://www.sci.muni.cz/botany/chytry/Zahora_etal2016_Zivotne-prostredie.pdf`]
  },
  {
    date: `2016`,
    name: `Jak velikost města ovlivňuje druhové složení vegetace?`,
    resources: [`Fórum ochrany přírody`],
    links: [`http://www.casopis.forumochranyprirody.cz/magazin/analyzy-komentare/jak-velikost-mesta-ovlivnuje-druhove-slozeni-vegetace`]
  },
    {
    date: `2016`,
    name: `Hádecké lomy – 15 let záchrany`,
    resources: [`Ochrana přírody`],
    links: [`http://www.casopis.ochranaprirody.cz/pece-o-prirodu-a-krajinu/hadecke-lomy-15-let-zachrany/`]
  },
    {
    date: `2015`,
    name: `Květena Brna – současný stav poznání`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/kvetena-brna-soucasny-stav-poznani.pdf`]
  },
  {
    date: `2014`,
    name: `Proč je flóra velkoměst pestrá`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/proc-je-flora-velkomest-pestra.pdf`]
  },

  {
    date: `2013`,
    name: `Botanické součty, rozdíly a podíly`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/botanicke-soucty-rozdily-a-podily.pdf`]
  },
 {
    date: `2013`,
    name: `Botanická fotogalerie a další pomůcky k určování rostlin`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/botanicka-fotogalerie-a-dalsi-pomucky-k-urcovani-r.pdf`]
  },

{
    date: `2012`,
    name: `GIS a jeho využití v botanice`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/gis-a-jeho-vyuziti-v-botanice.pdf`]
  },
  {
    date: `2012`,
    name: `Lesostep Jižního Uralu`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/lesostep-jizniho-uralu.pdf`]
  },

    {
    date: `2012`,
    name: `Ekosystémy Sibiře: analogie zaniklé přírody střední Evropy`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/ekosystemy-sibire-analogie-zanikle-prirody-stredni.pdf`]
  },
  {
    date: `2012`,
    name: `Rodinné stříbro české vegetace: máme u nás něco, co jinde nemají?`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/rodinne-stribro-ceske-vegetace-mame-u-nas-neco-co.pdf`]
  },
  {
    date: `2010`,
    name: `Fenomén subkontinentálních doubrav: diverzita, dynamika a historie jednoho neobyčejného společenstva`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/fenomen-subkontinentalnich-doubrav-diverzita-dynam.pdf`]
  },
     {
    date: `2010`,
    name: `Co je to fytocenologický snímek`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/co-je-to-fytocenologicky-snimek.pdf`]
  },
     {
    date: `2010`,
    name: `Kde dnes znamená včera. Jihosibiřské refugium doby ledové`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2010/cislo-9/kde-dnes-znamena-vcera.html`]
  },
  {
    date: `2010`,
    name: `Krajiny zamrzlé v čase I. Jižní Sibiř – současná analogie střední Evropy v době ledové`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/krajiny-zamrzle-v-case-i-jizni-sibir-soucasna-anal.pdf`]
  },
  {
    date: `2010`,
    name: `Krajiny zamrzlé v čase II. Jižní Ural – současná analogie střední Evropy ve starém a středním holocénu`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/krajiny-zamrzle-v-case-ii-jizni-ural-soucasna-anal.pdf`]
  },
  {
    date: `2009`,
    name: `Kam se šíří zavlečené rostliny? 1. Rozdíly v invadovanosti velkých území`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/kam-se-siri-zavlecene-rostliny-1-rozdily-v-invadov.pdf`]
  },
  {
    date: `2009`,
    name: `Kam se šíří zavlečené rostliny? 2. Invadovanost a invazibilita rostlinných společenstev`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/kam-se-siri-zavlecene-rostliny-2-invadovanost-a-in.pdf`]
  },
  {
    date: `2009`,
    name: `Kam se šíří zavlečené rostliny? 3. Obecné příčiny invazibility společenstev`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/kam-se-siri-zavlecene-rostliny-3-obecne-priciny-in.pdf`]
  },
  {
    date: `2008`,
    name: `„Taiwan? A mají tam vůbec nějaký les?“`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/taiwan-a-maji-tam-vubec-nejaky-les.pdf`]
  },
    {
    date: `2005`,
    name: `Sveřep stoklasa - starobylý plevel obilných polí`,
    resources: [`Živa`],
    links: [`https://ziva.avcr.cz/files/ziva/pdf/sverep-stoklasa-starobyly-plevel-obilnych-poli.pdf`]
  },
     {
    date: `2004`,
    name: `Rekultivace vápencových lomů`,
    resources: [`Vesmír`],
    links: [`https://vesmir.cz/cz/casopis/archiv-casopisu/2004/cislo-6/rekultivace-vapencovych-lomu.html`]
  },
];

export const popularizationEn = [];